import React, { useEffect, useState } from 'react';

/**
 * GurgenclerFikirler: lansman dönemi için dokuz fikrin kısa gösterimi.
 * Route: /r/gurgencler-lansman-fikirler (sidebar YOK, tam ekran slayt gösterisi)
 *
 * 5 slayt, 16:9. Tasarım dili ve görsel yardımcıları gurgencler-iletisim
 * klasöründen geliyor, o sunumun kısa ve fikir odaklı kardeşi.
 * Yeniden üretmek için: node src/pages/gurgencler-fikirler/build.js
 *
 * 🔑 "PDF olarak indir" düğmesi belgenin İÇİNDE. iframe dışından Ctrl+P
 * slaytları tek sayfaya kırpar; düğmeyi dışarı taşıma.
 *
 * HTML modülü ~25KB, ana bundle'da işi yok: dinamik import ile yükleniyor.
 */
export default function GurgenclerFikirler() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./gurgenclerFikirlerHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#1d1d1f">Sunum yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini sunumun kendi zemini (--deck) ile aynı, açılışta flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#F0F0F2' }} />;

  return (
    <iframe
      title="Gürgençler · Lansman Fikirleri"
      srcDoc={html}
      style={fill}
    />
  );
}
